import React from 'react'
import ReactDOM from 'react-dom';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import AuthProvider from 'AuthProvider/AuthProvider';
import Header from 'components/Header';
import Home from 'views/Home';
import Routes from './Routes';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
    },
  },
});

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <div className="App">
            <Header />
            <div className="Routes">
              <Switch>
                <Route exact path="/" component={Home} />
                <Route path="/missions" component={Routes} />
              </Switch>
            </div>
          </div>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}

ReactDOM.render(<App />, document.getElementById('root'));
